module.exports = __webpack_public_path__ + "static/store-14dc531235d02905e0a17ebc98e0449e.png";